const AUTHORIZATION_SLICE: string = "authorizationSlice";
const PRODUCTS_SLICE: string = "productsSlice";
const CATEGORIES_SLICE: string = "categoriesSlice";
const PROFILE_SLICE: string = "profileSlice";
const CARTS_SLICE: string = "cartsSlice";
const MERCHANT_SLICE: string = "merchantSlice";
const CREDITS_SLICE: string = "creditsSlice";
const VOUCHERS_SLICE: string = "vouchersSlice";
const MESSAGE_SLICE: string = "messagesSlice";
const CUSTOM_LIST_SLICE: string = "customListSlice";

export {
  AUTHORIZATION_SLICE,
  PRODUCTS_SLICE,
  PROFILE_SLICE,
  CATEGORIES_SLICE,
  MERCHANT_SLICE,
  CARTS_SLICE,
  CREDITS_SLICE,
  VOUCHERS_SLICE,
  MESSAGE_SLICE,
  CUSTOM_LIST_SLICE,
};
